module.exports = __webpack_public_path__ + "static/media/distribute-exp-mobile.b95f1d37.png";